// extracted by mini-css-extract-plugin
export default {"container":"rq-z","heading":"sq-z","text":"tq-z","info":"uq-z","link":"vq-z","fullMaxWidth":"wq-z"};